import {
  getOnboardingDisplayAllInGender,
  getOnboardingDisplaySexualOrientations,
} from 'Store/authOnboarding/selectors';
import {
  getUserLocalDisplayGenders,
  getUserLocalDisplayOrientations,
} from 'Store/profile/selectors';
import { InterestedInGender } from 'Store/profile/user.types';

import { AllInContextType, InterestedInGenderIntlId } from './types';

export const ALL_IN_CONTEXT_SEXUAL_ORIENTATION = 'sexual_orientation';
export const ALL_IN_CONTEXT_ONBOARDING_SEXUAL_ORIENTATION = 'onboarding_sexual_orientation';
export const ALL_IN_CONTEXT_GENDER = 'gender';
export const ALL_IN_CONTEXT_ONBOARDING_GENDER = 'onboarding_gender';

export const ALL_IN_CONTEXT_SELECTOR = {
  [ALL_IN_CONTEXT_GENDER]: getUserLocalDisplayGenders,
  [ALL_IN_CONTEXT_SEXUAL_ORIENTATION]: getUserLocalDisplayOrientations,
  [ALL_IN_CONTEXT_ONBOARDING_GENDER]: getOnboardingDisplayAllInGender,
  [ALL_IN_CONTEXT_ONBOARDING_SEXUAL_ORIENTATION]: getOnboardingDisplaySexualOrientations,
};

export const ALL_IN_PROFILE_USER_DATA_KEY: Record<AllInContextType, string> = {
  [ALL_IN_CONTEXT_GENDER]: 'display_genders',
  [ALL_IN_CONTEXT_SEXUAL_ORIENTATION]: 'display_sexual_orientations',
  [ALL_IN_CONTEXT_ONBOARDING_GENDER]: 'displayGenders',
  [ALL_IN_CONTEXT_ONBOARDING_SEXUAL_ORIENTATION]: 'displaySexualOrientations',
};

export const HEIGHT_TWO_QUARTERS = 'H(40%)';
export const HEIGHT_HALF = 'H(60%)';
export const HEIGHT_THREE_QUARTERS = 'H(80%)';
export const HEIGHT_FULL = 'H(100%)';

export const CONTENT_TYPE_VISIBILITY = 'visibility';
export const CONTENT_TYPE_SAFETY = 'safety';
export const CONTENT_TYPE_INCLUDE_ME_IN_SEARCHES_FOR = 'include_me_in_searches_for';
export const CONTENT_TYPE_FIND_YOUR_KIND = 'find_your_kind';
export const CONTENT_TYPE_FEEDBACK = 'feedback';
export const CONTENT_TYPE_ONBOARDING_FEEDBACK = 'onboarding_feedback';

export const BinarySet = new Set(['gen_3']);
export const ManBinarySet = new Set(['gen_1', ...[...BinarySet]]);
export const WomanBinarySet = new Set(['gen_2', ...[...BinarySet]]);
export const ManWomanSet = new Set(['gen_1', 'gen_2']);
export const ManWomanBinarySet = new Set([...[...ManWomanSet], ...[...BinarySet]]);

export const INTERESTED_IN_MEN_ID: InterestedInGenderIntlId = 'men';
export const INTERESTED_IN_WOMEN_ID: InterestedInGenderIntlId = 'women';
export const INTERESTED_IN_BEYOND_BINARY_ID: InterestedInGenderIntlId = 'beyondBinary';
export const INTERESTED_IN_EVERYONE_ID: InterestedInGenderIntlId = 'everyone';
export const INTERESTED_IN_MEN_KEY: InterestedInGender = 0;
export const INTERESTED_IN_WOMEN_KEY: InterestedInGender = 1;
export const INTERESTED_IN_BEYOND_BINARY_KEY: InterestedInGender = 2;
export const INTERESTED_IN_EVERYONE_COMBINATION: InterestedInGender[] = [
  INTERESTED_IN_MEN_KEY,
  INTERESTED_IN_WOMEN_KEY,
  INTERESTED_IN_BEYOND_BINARY_KEY,
];

export const ALL_IN_INTERESTED_IN_GENDERS_IDS_MAP: Map<
  InterestedInGender,
  InterestedInGenderIntlId
> = new Map([
  [INTERESTED_IN_MEN_KEY, INTERESTED_IN_MEN_ID],
  [INTERESTED_IN_WOMEN_KEY, INTERESTED_IN_WOMEN_ID],
  [INTERESTED_IN_BEYOND_BINARY_KEY, INTERESTED_IN_BEYOND_BINARY_ID],
]);

export const ALL_IN_REDACTED_INTERESTED_IN_GENDERS_IDS_MAP: Map<
  InterestedInGender,
  InterestedInGenderIntlId
> = new Map([
  [INTERESTED_IN_MEN_KEY, INTERESTED_IN_MEN_ID],
  [INTERESTED_IN_WOMEN_KEY, INTERESTED_IN_WOMEN_ID],
]);

export const INTERESTED_IN_GENDER_COMBINATION_VALUES: Map<
  InterestedInGenderIntlId,
  InterestedInGender[]
> = new Map([
  [INTERESTED_IN_MEN_ID, [INTERESTED_IN_MEN_KEY]],
  [INTERESTED_IN_WOMEN_ID, [INTERESTED_IN_WOMEN_KEY]],
  [INTERESTED_IN_BEYOND_BINARY_ID, [INTERESTED_IN_BEYOND_BINARY_KEY]],
  [INTERESTED_IN_EVERYONE_ID, INTERESTED_IN_EVERYONE_COMBINATION],
]);

export const INTERESTED_IN_REDACTED_GENDER_COMBINATION_VALUES: Map<
  InterestedInGenderIntlId,
  InterestedInGender[]
> = new Map([
  [INTERESTED_IN_MEN_ID, [INTERESTED_IN_MEN_KEY]],
  [INTERESTED_IN_WOMEN_ID, [INTERESTED_IN_WOMEN_KEY]],
  [INTERESTED_IN_EVERYONE_ID, [INTERESTED_IN_MEN_KEY, INTERESTED_IN_WOMEN_KEY]],
]);

export const OPTION_VALUE_NOT_LISTED = 'not_listed';

export const EDIT_ACTION = 'edit';
export const OPEN_ACTION = 'open';
export const ALL_IN_GENDER_SUBTYPE = 'identity_all_in';
export const LEGACY_GENDER_SUBTYPE = 'identity_legacy';
export const ALL_IN_ORIENTATION_SUBTYPE = 'all_in';
export const LEGACY_ORIENTATION_SUBTYPE = 'legacy';
export const ALL_IN_INTERESTED_IN_PROPERTY = 'preference_all_in';
export const LEGACY_INTERESTED_IN_PROPERTY = 'preference_legacy';
export const ALL_IN_GENDER_EVENT_TYPE = 'gender';
export const ALL_IN_SEXUAL_ORIENTATION_EVENT_TYPE = 'orientation';
export const ALL_IN_CUSTOM_GENDER_SUB_TYPE = 'all_in_custom_gender';
export const ALL_IN_CUSTOM_ORIENTATION_SUB_TYPE = 'all_in_custom_orientation';
export const ALL_IN_EDIT_PROFILE_GENDER_APP_SOURCE = 'editprofile_gender';
export const ALL_IN_EDIT_PROFILE_SEXUAL_ORIENTATION_APP_SOURCE = 'editprofile_orientation';
export const ALL_IN_EDIT_PROFILE_SOURCE = 'editprofile';

export const ALL_IN_TOGGLE_ACTION = 'toggle';
export const ALL_IN_VIEW_ACTION = 'view';
export const ALL_IN_EDIT_ACTION = 'edit';

export const ALL_IN_TINDER_CARES = 'Tinder Cares';

export const ALL_IN_SETTING_PROPERTY = 'setting';
